<div class="date-time-picker-container">
  <!-- PRE SELECTION -->
  @if (preSelectionRange) {
    <div class="pre-selection">
      <select name="selectFormatedDate" class="selectFormatedDate" #selectFormatedDate (change)="onChangePreSelection($event.target.value)">
        @for (preselection of preselections; track preselection; let i = $index) {
          <option [value]="preselection.id" [selected]="preselection.selected">
            {{preselection.name}}
          </option>
        }
      </select>
    </div>
  }
  <!-- START DATE -->
  <div class="start-date">
    <dp-date-picker #startDatePicker #startDate="ngModel" [(ngModel)]="startDateFilter" [config]="startDatePickerConfig" mode="daytime" (onSelect)=onStartDatePickerSelect($event) [title]="(startDate.invalid && startDate.dirty) ? 'Date ou heure invalide' : ''"
    name="startDateFilter" required></dp-date-picker>
  </div>
  <!-- END DATE -->
  <div class="end-date">
    <dp-date-picker #endDatePicker #endDate="ngModel" [(ngModel)]="endDateFilter" [config]="endDatePickerConfig" mode="daytime" (onSelect)=onEndDatePickerSelect($event) [title]="(endDate.invalid && endDate.dirty) ? 'Date ou heure invalide' : ''" name="endDateFilter"
    required></dp-date-picker>
  </div>
  <!-- RANGE/GRANULARITY -->
  @if (graphChoicesStepEnabled) {
    <!-- calculation -->
    <div class="pre-selection">
      <select class="selectFormatedDate" [(ngModel)]="currentCalculation">
        @for (calculation of calculationTypes; track calculation; let i = $index) {
          <option [ngValue]="calculation">{{ 'calculation.' + calculation |translate}}</option>
        }
      </select>
    </div>
    <!-- step -->
    <div class="pre-selection">
      <select class="selectFormatedDate" [(ngModel)]="currentStepType" [disabled]="currentCalculation === CALCULATION_FUNCTION.RAW">
        @for (stepType of stepTypes; track stepType; let i = $index) {
          <option [ngValue]="stepType">{{ 'stepType.' + stepType |translate}}</option>
        }
      </select>
    </div>
    <!-- range -->
    <div class="pre-selection">
      <input type="number" class="inputFormated" [(ngModel)]="currentStepRange" min="1" [disabled]="currentCalculation === CALCULATION_FUNCTION.RAW">
    </div>
  }
  <!-- APPLY -->
  <ng-container>
    <div class="date-time-picker-apply">
      <button (click)="applySelection()" class='btn_app table-action' [disabled]="errorDate.length > 0">
        {{'action.apply' | translate}}
      </button>
    </div>
  </ng-container>

</div>
@if (errorDate && errorDate.length > 0) {
  <div class="date-time-picker-errors">
    <span>{{ errorDate }}</span>
  </div>
}